import '../../../styles/counseling/CounselingHome.css'

export const WellReminderHeaderSkeleton = () => {
    return (
        <div className="well-reminder-header flex flex-row gap-4 mb-4">
            <div className="h-[55px] w-[40%] bg-lightBG rounded-full opacity-50"></div>
            <div className="h-[55px] w-[60%] bg-lightBG rounded-full opacity-50"></div>
        </div>
    )
}

export const TypeOptionsListsSkeleton = () => {
    return (
        <div className="light-small-scroll">
            {[...Array(5)].map((_, idx) => (
                <div key={idx} className="well-tracker-card flex items-center gap-4 bg-[#ecebf8] rounded-[5px] p-5">
                    <div className="flex flex-col gap-2 flex-1">
                        <div className="h-5 w-[120px] bg-lightBG rounded opacity-50"></div>
                        <div className="h-4 w-[80px] bg-lightBG rounded opacity-30"></div>
                    </div>
                    <div style={{ flex: 1 }}></div>
                    <div className="h-6 w-[80px] bg-lightBG rounded opacity-30"></div>
                    <div className="well-arrow-right ml-4">
                        <div className="h-8 w-8 bg-lightBG rounded-full opacity-50"></div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export const AssignedActionListSkeleton = () => {
    return (
        <div>
            {[...Array(3)].map((_, idx) => (
                <div key={idx} className="rounded-xl my-2 border border-lightBG animate-pulse">
                    <div className="p-5 rounded-xl bg-lightBG">
                        <div className="flex flex-row mb-[20px]">
                            <div className="mr-[15px] flex flex-row gap-[4px]">
                                <div className="w-[32px] h-[32px] bg-mudPurple rounded-full opacity-50"></div>
                                <div className="w-[32px] h-[32px] bg-mudPurple rounded-full opacity-50"></div>
                                <div className="w-[32px] h-[32px] bg-mudPurple rounded-full opacity-50"></div>
                            </div>
                        </div>
                        <div>
                            <div className="h-4 w-full bg-mudPurple rounded opacity-30 mb-[10px]"></div>
                        </div>
                        <div className="flex flex-row justify-between mt-[25px]">
                            <div className="h-4 w-[30%] bg-mudPurple rounded opacity-30 mb-[10px]"></div>
                            <div className="h-4 w-[30%] bg-mudPurple rounded opacity-30 mb-[10px]"></div>
                        </div>
                        <div className="mt-[25px]">
                            <div className="h-4 w-[60%] bg-mudPurple rounded opacity-30 mb-[10px]"></div>
                        </div>
                        <div className="flex gap-2 mt-[35px]">
                            <div className="h-[42px] w-[147px] bg-mudPurple rounded-full opacity-30"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
